import './logo.css';

var styles = {"heading":"heading__1bx6n","logo":"logo__2KOw5","logoMini":"logoMini__BpbW6","headingMini":"headingMini__3jPh_","headingDefault":"headingDefault__CoT8o","primeDayLogo":"primeDayLogo__3IwyP","slide":"slide__3wK_3","logoWrapper":"logoWrapper__3wwsu","slideWrapper":"slideWrapper__2oBIQ"};

export { styles as default };
